module.exports = __webpack_public_path__ + "img/cneter_s.735a6a07.svg";